module.exports = __webpack_public_path__ + "static/media/image4.8ee4070c.jpg";